/**
 * Conversation feedback validation.
 *
 * Once a rating is picked we require context for it, whatever the score, so
 * every submitted rating carries a reason we can act on instead of a bare
 * number. Either at least one tag or a non-empty comment satisfies it. Before a
 * rating is chosen nothing is required — the user can still skip or close the
 * modal.
 */

/**
 * @param {number} rating - Star rating (0 when none selected).
 * @param {string[]} [selectedTags] - Selected feedback tags.
 * @param {string} [comment] - Free-text comment.
 * @returns {boolean} True when the user must add a tag or comment before submitting.
 */
export function isFeedbackRequired(rating, selectedTags = [], comment = '') {
  const hasRating = rating > 0;
  const hasWrittenFeedback = selectedTags.length > 0 || comment.trim().length > 0;
  return hasRating && !hasWrittenFeedback;
}
